import Butter from 'buttercms';
const butter = Butter('bfe1c88a6a1f0057d64869b452367c541e8826c3');
export default butter